type AudioObject = {
  derivedFromAudioId: null;
  originalAudioId: number;
  originalAudioWebId: string;
  audioId: string;
  audioTransformationStatus: string | null;
  audioTransformationName: string | null;
  caption: string | null;
  color: string;
  created: string;
  modified: string;
  doesHaveGeneratedVideo: boolean;
  duration: number;
  key: string;
  sort: number;
  userId: number;
  url: string;
  type: string;
};

export function getIsWaitingForAudioTransformation(audios: AudioObject[]) {
  const isWaiting = audios.some((audio: AudioObject) => {
    const { audioTransformationStatus } = audio;
    if (!audioTransformationStatus) return false;
    return ['waiting', 'started'].includes(audioTransformationStatus);
  });
  return isWaiting;
}

export function getTimeoutDuration(attempts: number) {
  if (attempts < 10) return 1000;
  if (attempts < 30) return 3000;
  if (attempts < 60) return 5000;
  return 10000;
}
